import { Button } from '@talentmesh/ui/components/button';
import { cn } from '@talentmesh/ui/lib/utils';
import InformationOptionLabel from './InformationOptionLabel';
import UIStrings from '@/Utils/UIStrings';

interface MandatoryInformationOptionProps {
    label: string;
}

const MandatoryInformationOption = ({ label }: MandatoryInformationOptionProps) => {
    return (
        <div className="flex flex-row flex-wrap items-center justify-between gap-4 px-10 py-4">
            <InformationOptionLabel label={label} />
            <Button type="button" size="sm" variant="default" className={cn('min-w-24 px-4')}>
                {UIStrings.Mandatory}
            </Button>
        </div>
    );
};

export default MandatoryInformationOption;
